import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    DUPLICATE_TEMPLATE,
    DUPLICATE_TEMPLATE_FAILURE,
    DUPLICATE_TEMPLATE_SUCCESS,
    FETCH_FILTER_TEMPLATES,
    FETCH_FILTER_TEMPLATES_FAILURE,
    FETCH_FILTER_TEMPLATES_SUCCESS,
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    SET_FILTER_DATA,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: {
        errors: null,
        isFetching: false,
    },
    duplicateTemplate: {
        errors: null,
        isDuplicating: false,
    },
    filterData: {},
    filterTemplates: {
        data: {
            data: [],
            paginaton: {},
        },
        errors: [],
        isFetching: false,
    },
    save: {
        isSaving: false,
        data: {},
        errors: null,
    },
};

const templatesSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: [],
                isFetching: true,
            };
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: action.payload,
                isFetching: false,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                isFetching: false,
            };
        },
        [DUPLICATE_TEMPLATE]: (state) => {
            state.duplicateTemplate = {
                ...state.duplicateTemplate,
                errors: [],
                isDuplicating: true,
            };
        },
        [DUPLICATE_TEMPLATE_FAILURE]: (state, action) => {
            state.duplicateTemplate = {
                ...state.duplicateTemplate,
                errors: action.payload,
                isDuplicating: false,
            };
        },
        [DUPLICATE_TEMPLATE_SUCCESS]: (state) => {
            state.duplicateTemplate = {
                ...state.duplicateTemplate,
                isDuplicating: false,
            };
        },
        [FETCH_FILTER_TEMPLATES]: (state, action) => {
            state.filterTemplates = {
                ...state.filterTemplates,
                query: action.payload,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_FILTER_TEMPLATES_FAILURE]: (state, action) => {
            state.filterTemplates = {
                ...state.filterTemplates,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_FILTER_TEMPLATES_SUCCESS]: (state, action) => {
            state.filterTemplates = {
                ...state.filterTemplates,
                data: action.payload,
                isFetching: false,
            };
        },
        [SAVE]: (state) => {
            state.save = {
                ...state.save,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SUCCESS]: (state) => {
            state.save = {
                ...state.save,
                isSaving: false,
            };
        },
        [SET_FILTER_DATA]: (state, action) => {
            state.filterData = action.payload;
        },
    },
});

export const templatesActions = templatesSlice.actions;

export default templatesSlice.reducer;
